import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth/auth.service';
import * as jwt_decode from 'jwt-decode';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { MatRadioChange, MatRadioButton } from '@angular/material/radio';
import { LoginRequestVM } from 'src/app/viewModels/login/login-request-vm';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { TokenValidateRequestVM } from 'src/app/viewModels/login/token-validate-request-vm';
import { CommonService } from 'src/app/middleware/common/common.service';
import { CommonDialogComponent } from 'src/app/middleware/shared/dialogueBoxes/common/common-dialog.component';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { CookieService } from 'ngx-cookie-service';
import { Subscription, timer } from 'rxjs';
import { HttpClient,HttpBackend } from '@angular/common/http';
import { DatePipe } from '@angular/common';
const { detect } = require('detect-browser');
const browser = detect();

@Component({
  selector: 'app-VerifyIP',
  templateUrl: './VerifyIP.component.html',
  styleUrls: ['./VerifyIP.component.scss'],
  providers: [DatePipe]
})
export class VerifyIPComponent implements OnInit {
  verifyToken: any;
  spinner:boolean=false;
  constructor(private http: HttpClient,private activatedRoute: ActivatedRoute,private httpbackend:HttpBackend,private _formBuilder: FormBuilder,
    private loginRequestVM: LoginRequestVM, private encryptionAlgo: EncryptionService, 
    private reusableClass: ReusableClasses, private authService: AuthService, private statusConst: StatusConstant,
    private tokenValidationReqVM: TokenValidateRequestVM, private commonService: CommonService,
    private matDialog: MatDialog, public dialogRef: MatDialogRef<CommonDialogComponent>,
    private loaderService: LoaderService, private toastr: ToastrService, private router: Router,
    private constant: Constants,private dialog: MatDialog,
    private customValidator: CustomvalidationService,private cookieService: CookieService,
    public datepipe: DatePipe) {
      var skipper = new HttpClient(httpbackend);
      skipper.get<{ip:string}>('https://jsonip.com').subscribe( data => {       
        this.ipAddress = data.ip;
      });
  }

  ipAddress:any;
  browsername:any;
  device:any;

  
  private queryParamSubscription: Subscription;
  ngOnInit(): void {
    this.queryParamSubscription = this.activatedRoute.queryParams.subscribe(params => {
      // Here, 'params' is an object containing the query parameters
      this.verifyToken = params['token']; // Replace 'myParam' with the name of your query parameter
      // Now you can use 'myParam' as needed
      if(params['token']!=undefined && params['token']!=null)
      {
        this.VerifyNewIp();
      }
    });
   
  }

  

  VerifyNewIp(){
    let decodedToken=decodeURIComponent(this.verifyToken);
      var reqModel={
        Token: encodeURIComponent(decodedToken),
        email: sessionStorage.getItem('portalemail')
      }
      this.loaderService.show();
      this.spinner=true;
      this.authService.VerifyNewIp(reqModel).subscribe(response => {
     let  responseHolder:any;
     responseHolder=response;
        if (responseHolder.status==200) {
          if(responseHolder.data.tokenStatus==4)
          {

          this.verifyToken=undefined;
          responseHolder = response;
          this.toastr.success("The process has been successfully completed. Thank you for waiting!", '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
          this.spinner=false;
          sessionStorage.setItem('LoginToken',responseHolder.data.token);
          this.router.navigate([`/request/portal`]);

        }
        }
        else
        {
          this.toastr.error("An error occurred during the process.", '', {
            timeOut: 3000,
          });
        }
      });
  }

}
